

export const CONFIG = {
  REACT_APP_ENDPOINT: localStorage.getItem("ipConfig"),
  REACT_APP_UPLOADS: localStorage.getItem("ipConfig") + "/uploads"
};

// export const MASTERCONFIG = {
//   REACT_APP_ENDPOINT: "http://localhost:5050",
//   REACT_APP_UPLOADS: "http://localhost:5050" + "/uploads",
// };
// export const CONFIG = {
//   REACT_APP_ENDPOINT: "https://admin.prabhuchat.com",
//   REACT_APP_UPLOADS: "https://admin.prabhuchat.com/uploads"
// }

export const MASTERCONFIG = {
  REACT_APP_ENDPOINT: "https://master.prabhuchat.com",
  REACT_APP_UPLOADS: "https://master.prabhuchat.com" + "/uploads",
};